
export enum OfferOrderSortingType {
    CreateDateAsc = "CREATE DATE ASCENDING",
    CreateDateDesc = "CREATE DATE DESCENDING",
    LastModificationDateAsc = "LAST MODIFICATION DATE ASCENDING",
    LastModificationDateDesc = "LAST MODIFICATION DATE DESCENDING",
    Status = "STATUS"
}
